import { scrollbar, theme } from '@pocketlaw/tetris';
import styled from 'styled-components';
export const Container = styled.div `
  margin-right: ${theme.spacing.sm};
  padding: ${theme.spacing['2xl']};
  overflow: hidden auto;
  ${scrollbar({ trackMargin: 'sm' })};
`;
